import axios from "axios";
import { API_URL } from "@/config";

const store = {
  namespaced: true,

  actions: {
    async getManyAutomatedReports(_, criteria) {
      const res = await axios.get(`${API_URL}/automatedReports`, { params: criteria });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getManyAutomatedReportsForExternalUser(_, criteria) {
      const res = await axios.get(`${API_URL}/automatedReportsForExternalUser`, {
        params: criteria,
      });

      if (!res.data || typeof res.data.items !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async getAutomatedReport(_, automatedReportId) {
      const res = await axios.get(`${API_URL}/automatedReports/${automatedReportId}`);

      if (!res.data || typeof res.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data;
    },

    async createAutomatedReport(_, automatedReportData) {
      const res = await axios.post(`${API_URL}/automatedReports`, automatedReportData);

      if (!res.data || typeof res.data !== "object" || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async updateAutomatedReport(_, { automatedReportId, automatedReportData }) {
      const res = await axios.put(
        `${API_URL}/automatedReports/${automatedReportId}`,
        automatedReportData,
      );

      if (!res.data || typeof res.data !== "object" || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async removeAutomatedReport(_, automatedReportId) {
      const res = await axios.delete(`${API_URL}/automatedReports/${automatedReportId}`);

      if (!res.data || typeof res.data !== "object" || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async bulkEnable(_, automatedReportIds) {
      const res = await axios.post(`${API_URL}/automatedReports/bulk/enable`, {
        automatedReportIds,
      });

      if (!res.data || typeof res.data !== "object" || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async bulkDisable(_, automatedReportIds) {
      const res = await axios.post(`${API_URL}/automatedReports/bulk/disable`, {
        automatedReportIds,
      });

      if (!res.data || typeof res.data !== "object" || !res.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getArchivedReportDownloadUrl(_, archivedReportId) {
      const res = await axios.get(
        `${API_URL}/automatedReports/archived/${archivedReportId}/downloadUrl`,
      );

      if (!res.data || typeof res.data !== "object" || !res.data.url) {
        throw new Error("Error occurred while processing your request.");
      }

      return res.data.url;
    },
  },
};

export default store;
